export default {
    methods: {

        openModal(element) {
            $('.' + element).modal().appendTo("body").show()
        },

        isModalOpen(element) {
            return !!(($('.' + element).data('bs.modal') || {}).isShown)
        },

        closeModal(element) {
            $('.' + element).modal('hide')
        },
    }
}
